import type { MediaItem } from '@/types';

interface VideoPreviewProps {
  media: MediaItem;
}

export default function VideoPreview({ media }: VideoPreviewProps) {
  const formatDuration = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formatSize = (bytes: number): string => {
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(1)} MB`;
  };

  return (
    <div className="overflow-hidden rounded-lg border border-border">
      <video
        src={media.url}
        controls
        className="w-full max-h-96 bg-black"
        preload="metadata"
      />
      <div className="bg-surface p-3">
        <div className="grid grid-cols-2 gap-2 text-sm sm:grid-cols-4">
          {media.width && media.height && (
            <div>
              <p className="text-muted-foreground">Resolution</p>
              <p className="font-medium text-foreground">{media.width}x{media.height}</p>
            </div>
          )}
          {media.duration && (
            <div>
              <p className="text-muted-foreground">Duration</p>
              <p className="font-medium text-foreground">{formatDuration(media.duration)}</p>
            </div>
          )}
          <div>
            <p className="text-muted-foreground">Size</p>
            <p className="font-medium text-foreground">{formatSize(media.size)}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Type</p>
            <p className="font-medium text-foreground">{media.mimeType.split('/')[1].toUpperCase()}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
